import { render, staticRenderFns } from "./JobAlertForm.vue?vue&type=template&id=36b049e8&"
import script from "./JobAlertForm.vue?vue&type=script&lang=js&"
export * from "./JobAlertForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports